'use strict';

goog.provide("Ntry.ConfigManager");

Ntry.ConfigManager = function() {
    this.configurations = {};
};

(function(p){
    p.loadConfig = function(configurations) {
        this.configurations = configurations;
    };

    p.setConfig = function(key, value) {
        this.configurations[key] = value;
    };

    p.getConfig = function(key) {
        return this.configurations[key];
    };

    p.deleteConfig = function(key) {
        delete this.configurations[key];
    };

})(Ntry.ConfigManager.prototype);
